import Vue from 'vue'
import VueModalDialogs from 'vue-components/plugins/vue-modal-dialogs/vue-modal-dialogs'

Vue.use(VueModalDialogs)



// WEBPACK FOOTER //
// ./src/plugins/vue-modal-dialogs.js